import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Globe, Award, Users } from 'lucide-react';
import { services, stats } from '../mock';

const Home = () => {
  return (
    <div style={{ background: 'var(--bg-page)' }}>
      {/* Hero Section */}
      <section style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        padding: '120px 0 80px'
      }}>
        {/* Background Image with Overlay */}
        <div style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          overflow: 'hidden'
        }}>
          <img
            src="https://images.pexels.com/photos/4173217/pexels-photo-4173217.jpeg"
            alt="Professional Business Travel"
            style={{
              objectFit: 'cover',
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0
            }}
          />
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.85), rgba(26, 28, 27, 0.7))',
            opacity: 0.9
          }}></div>
        </div>

        {/* Hero Content */}
        <div className="container" style={{
          position: 'relative',
          zIndex: 1,
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{ maxWidth: '800px' }}>
            <div className="caption" style={{
              color: 'var(--brand-primary)',
              marginBottom: '20px'
            }}>
              Service Exclusif • Disponibilité 24/7
            </div>
            <h1 className="brand-display" style={{
              marginBottom: '30px',
              color: 'var(--brand-primary)'
            }}>
              L'Agence
            </h1>
            <h2 className="heading-3" style={{
              color: '#FFFFFF',
              marginBottom: '30px',
              textTransform: 'none'
            }}>
              Billeterie corporate & conciergerie de voyage 24/7
            </h2>
<p className="body-large" style={{
              marginBottom: '40px',
              color: '#E5E7EB',
              maxWidth: '600px'
            }}>
              Votre partenaire dédié pour des déplacements professionnels fluides, sécurisés et parfaitement orchestrés.
            </p>
            <div style={{
              display: 'flex',
              gap: '20px',
              flexWrap: 'wrap'
            }}>
              <Link to="/contact" className="btn-primary">
                Demander un devis <ArrowRight size={20} />
              </Link>
              <Link to="/a-propos" className="btn-secondary" style={{
                borderColor: '#FFFFFF',
                color: '#FFFFFF'
              }}>
                Découvrir nos services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section style={{
        padding: '120px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '60px',
            alignItems: 'center'
          }}>
            <div>
              <h2 className="heading-2" style={{
                color: 'var(--brand-primary)',
                marginBottom: '30px'
              }}>
                Pourquoi L'Agence existe ?
              </h2>
            </div>
            <div style={{ gridColumn: 'span 2' }}>
              <p className="body-medium" style={{
                marginBottom: '20px',
                color: 'var(--text-secondary)'
              }}>
                De nombreuses entreprises consacrent aujourd'hui un temps précieux à organiser des voyages, coordonner des équipes en déplacement ou gérer des événements corporate — des tâches chronophages qui ne relèvent pas de leur cœur de métier.
              </p>
              <p className="body-medium" style={{
                color: 'var(--text-secondary)'
              }}>
                L'Agence a été créée pour leur permettre de se recentrer entièrement sur leur activité principale, pendant que nous prenons en charge l'intégralité de leurs besoins de voyage et d'événementiel.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{
        padding: '80px 0',
        background: 'var(--secondary-olive)',
        borderTop: '1px solid var(--border-medium)',
        borderBottom: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '60px',
            textAlign: 'center'
          }}>
            {stats.map((stat, index) => (
              <div key={index}>
                <div className="heading-2" style={{
                  color: 'var(--brand-primary)',
                  marginBottom: '10px'
                }}>
                  {stat.value}
                </div>
                <div className="caption" style={{
                  color: 'var(--text-secondary)'
                }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section style={{
        padding: '120px 0',
        background: 'var(--bg-page)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '80px'
          }}>
            <h2 className="heading-2" style={{
              color: 'var(--brand-primary)',
              marginBottom: '20px'
            }}>
              Nos Services
            </h2>
            <p className="body-large" style={{
              color: 'var(--text-secondary)',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Un service exclusif, non standardisé, réservé à un nombre très limité de clients.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '40px'
          }}>
            {services.map((service) => (
              <div key={service.id} style={{
                background: 'var(--bg-card)',
                border: '1px solid var(--border-medium)',
                padding: '40px',
                transition: 'transform 0.3s ease, background-color 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.backgroundColor = 'var(--secondary-olive)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.backgroundColor = 'var(--bg-card)';
              }}>
                <h3 className="heading-4" style={{
                  color: 'var(--brand-primary)',
                  marginBottom: '20px',
                  textTransform: 'uppercase'
                }}>
                  {service.title}
                </h3>
                <p className="body-small" style={{
                  marginBottom: '30px',
                  color: 'var(--text-secondary)'
                }}>
                  {service.description}
                </p>
                <ul style={{
                  listStyle: 'none',
                  padding: 0,
                  marginBottom: '30px'
                }}>
                  {service.features.slice(0, 4).map((feature, idx) => (
                    <li key={idx} style={{
                      marginBottom: '10px',
                      color: 'var(--text-secondary)',
                      fontSize: '0.95rem',
                      paddingLeft: '20px',
                      position: 'relative'
                    }}>
                      <span style={{
                        position: 'absolute',
                        left: 0,
                        color: 'var(--brand-primary)'
                      }}>•</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link to={`/${service.slug}`} className="btn-secondary" style={{
                  width: '100%',
                  justifyContent: 'center'
                }}>
                  En savoir plus <ArrowRight size={18} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section style={{
        padding: '120px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '60px',
            textAlign: 'center'
          }}>
            Pourquoi choisir L'Agence ?
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '40px'
          }}>
            {[
              { icon: Clock, title: 'Disponibilité 24/7', desc: 'Assistance personnelle continue pour tous vos besoins' },
              { icon: Award, title: 'Service Exclusif', desc: 'Nombre limité de clients pour une qualité irréprochable' },
              { icon: Globe, title: 'Coordination Internationale', desc: 'Expertise multi-pays en Afrique, Europe, Asie et Moyen-Orient' },
              { icon: Users, title: 'Collaboration Totale', desc: 'Synergie avec vos équipes RH, finance et direction' }
            ].map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} style={{
                  padding: '30px',
                  textAlign: 'center'
                }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    margin: '0 auto 20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid var(--brand-primary)',
                    borderRadius: '50%'
                  }}>
                    <Icon size={36} color="var(--brand-primary)" />
                  </div>
                  <h3 className="heading-4" style={{
                    color: 'var(--brand-primary)',
                    marginBottom: '15px',
                    fontSize: '1.1rem'
                  }}>
                    {item.title}
                  </h3>
                  <p className="body-small" style={{
                    color: 'var(--text-secondary)'
                  }}>
                    {item.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '120px 0',
        background: 'var(--bg-page)',
        borderTop: '1px solid var(--border-medium)'
      }}>
        <div className="container" style={{
          maxWidth: '87.5rem',
          margin: '0 auto',
          padding: '0 40px',
          textAlign: 'center'
        }}>
          <h2 className="heading-2" style={{
            color: 'var(--brand-primary)',
            marginBottom: '30px'
          }}>
            Prêt à simplifier vos voyages d'affaires ?
          </h2>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            marginBottom: '40px',
            maxWidth: '600px',
            margin: '0 auto 40px'
          }}>
            Contactez-nous dès aujourd'hui pour discuter de vos besoins et découvrir comment L'Agence peut transformer votre gestion des déplacements professionnels.
          </p>
          <div style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <Link to="/contact" className="btn-primary">
              Demander un devis <ArrowRight size={20} />
            </Link>
            <a href="tel:+243841223949" className="btn-secondary">
              Appeler maintenant
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;